import React, {useState, useEffect} from 'react';
import { UpcommingEvent } from 'components/dashboard/home/Event';
import { EventSkeloeton } from './EventSkeloeton';
// import event1 from "../../../../../assets/images/event1.png"
// import event2 from "../../../../../assets/images/event2.png"
// import event3 from "../../../../../assets/images/event3.png"
import { useNavigate } from 'react-router-dom';
import { EventServices } from 'services/event';
import { PaginationSection } from 'components/pagination/newPagination';
const Events = () => {
  const [allEvent, setAllEvents] = useState([])
  const [isLoading, setLoading]= useState(false)
  const navigate = useNavigate()
  const handleViewClick = (id) => {
    const selectedEvent = allEvent?.find((events) => events.id === id);
    navigate("../events/event-details", {
      state: { eventData: selectedEvent }, // Pass the entire row data as state
    });
    localStorage.setItem("#eventRow", JSON.stringify(selectedEvent.id));
    // console.log("View event Detail", selectedEvent.id);
  };

  
useEffect(() => {
  getAllEvents();
}, []);

const getAllEvents = async () => {
  setLoading(true);
  try {
    const response = await EventServices.fetchEvents();
    // console.log("fetch event", response);
    if (response.data.status === 'success') {
      const res = response.data.data.details;
      const sortedEvents = res?.rows.sort((a, b) => new Date(a.date) - new Date(b.date));
setAllEvents(sortedEvents);

      setLoading(false);
    }
    setLoading(false);
  } catch (error) {
    setLoading(false);
    console.log(error);
  }
};
  
    // pagination section
    const [currentPage, setCurrentPage] = useState(1);
    const postsPerPage = 5
    const lastPostIndex = currentPage * postsPerPage;
    const firstPostIndex = lastPostIndex - postsPerPage;
    const currentTableData = allEvent?.slice(firstPostIndex, lastPostIndex);
      // Calculate total pages
      const totalPosts = allEvent?.length;
      // Function to handle changing pages
      const handlePageChange = (page) => {
        setCurrentPage(page);
      };

  return (
    <div className='p-6 bg-gray-100 flex-1 overflow-auto'>
      <div className='bg-white p-4 rounded shadow-md'>
        {/* <h2 className='text-2xl font-semibold'>Events</h2>
        <p className='mt-4 text-gray-600'>Coming Soon</p> */}
        {
          isLoading ? (<EventSkeloeton />):(
            <UpcommingEvent  data={currentTableData} event={true} handleViewClick={handleViewClick} />
          )
        }
      </div>
      <div className="w-full  ">
          <PaginationSection
              totalPosts={totalPosts}
              postsPerPage={postsPerPage}
              currentPage={currentPage}
              setCurrentPage={handlePageChange}
            />
          </div>
    </div>
  );
};

export default Events;
